import React, { useState } from 'react';
import styles from './SurveyableField.module.css';
import { get } from '../../utils/utils';
import { AdminCheckbox, AdminSelect } from '@project/components';
import { useIntl } from 'react-intl';

const classNames = require('classnames');


const SurveyableField = ({ form, isReadOnly, formKey, isSurveyed, updateField, saveForm, fieldKey: key, children }) => {
  const fieldName = key.split('.').pop() + '_not_surveyed';

  const notSurveyedValue = get(form, `${formKey}.${fieldName}`);

  // state for the not surveyed checkbox
  const [notSurveyed, setNotSurveyed] = useState(!!notSurveyedValue);

  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const surveyOptions = [
    { value: 'Construction Onsite', label: t('SurveyableField.notSurveyedOption.construction') },
    { value: 'Equipment Issues', label: t('SurveyableField.notSurveyedOption.equipmentIssues') },
    { value: 'No Access', label: t('SurveyableField.notSurveyedOption.noAccess') },
    { value: 'Not Provided', label: t('SurveyableField.notSurveyedOption.notProvided') },
    { value: 'Not Present', label: t('SurveyableField.notSurveyedOption.notPresent') },
    { value: 'Not Part of Scope', label: t('SurveyableField.notSurveyedOption.notPartOfScope') },
    { value: 'Poor Weather', label: t('SurveyableField.notSurveyedOption.weather') },
    { value: 'Permanent Ceiling', label: t('SurveyableField.notSurveyedOption.permanentCeiling') },
    { value: 'Insulation', label: t('SurveyableField.notSurveyedOption.insulation') },
    { value: 'Safety Concerns', label: t('SurveyableField.notSurveyedOption.safety') },
    { value: 'Tenant Denied', label: t('SurveyableField.notSurveyedOption.tenantDenied') },
    { value: 'Lockbox Issues', label: t('SurveyableField.notSurveyedOption.lockboxIssues') }
  ];

  const saveNotSurveyedReason = e => {
    const formValue = { target: { type: 'select', value: e.value, checked: false } }
    updateField(fieldName, formValue, get(form, formKey), false, key)
    saveForm(true);
  }

  if (!fieldName) return null;

  // render just the wrapped component if the field is not surveyable
  if (!isSurveyed) return children;

  return (
    <>
      {children}
      <div>
        <AdminCheckbox
          id={`${key}_${fieldName}`}
          label={t('SurveyableField.notSurveyed')}
          checked={notSurveyed}
          readOnly={isReadOnly}
          removeMargins={true}
          justifyContent={false}
          onChange={e => {
            setNotSurveyed(e.target.checked);
            if (!e.target.checked) saveNotSurveyedReason({ value: '' });
          }}
          customLabelStyle={styles.notSurveyedCheckboxLabel}
          customstyle={styles.notSurveyedCheckbox}
        />
      </div>
      <div className={styles.notSurveyedInputs}>
        {
          notSurveyed ?
            <AdminSelect
              id={`${key}_${fieldName}_reason`}
              options={surveyOptions}
              label=""
              value={surveyOptions.filter(option => option.value === notSurveyedValue)}
              onChange={saveNotSurveyedReason}
              className={classNames(styles.notSurveyedSelect)}
              isDisabled={isReadOnly}
              placeholder={t('SurveyableField.notSurveyedReason')}
              data-testid="not-survey-reason"
              identifierClass={'data-not-survey-reason'} />
            : null
        }
      </div>
    </>
  )
}

export default SurveyableField;
